import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedApp: null
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setSelectedApp: (state, {payload}) => { state.selectedApp = payload; },
        resetApp: (state) => { state.selectedApp =  null; },
    }
});

export const {
    setSelectedApp,
    resetApp
} = appSlice.actions;

export default appSlice.reducer;